module.exports = __webpack_public_path__ + "img/eprf-inventory.ac5e8ec8.png";